import { useEffect, useRef, useState } from "react";
import PropertyFilterData from "../../pages/Properties/components/PropertyFilterData";
import { initialPropertyFilterData } from "../../utils/initialData";
import userStorage from "../../utils/userStorage";
import { countNonMatchingEntries, handleDropdownClose } from "../../utils/utils";
import RightModal from "../Modal/RightModal";
import SavedFilterComponent from "../SavedFilters/SavedFilterComponent";

const PropertyFilter = ({ filterData, onSetFilterData, onCallApiAgain, setError }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = userStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialPropertyFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    userStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleFilterChange = (value, name) => {
    onSetFilterData({ ...filterData, [name]: value });
  };

  const saveSearchFilterData = {
    store_id: filterData?.storeId,
    property_name: filterData?.propertyName,
    property_type: filterData?.propertyType,
    street_address: filterData?.streetAddress,
    city: filterData?.city,
    state: filterData?.state,
    zip_code: filterData?.zip,
    date_category: filterData?.lastUpDateCategory,
    lastcontactCategory: filterData?.date_category_contact,
    within_last_day: filterData?.withinLastDay,
    longer_than_day: filterData?.longerThanDay,
    min_rate: filterData?.minCaprate,
    max_rate: filterData?.maxCaprate,
    building_min_size: filterData?.minBuilding,
    building_max_size: filterData?.maxBuilding,
    min_price: filterData?.minPrice,
    max_price: filterData?.maxPrice,
    land_min_size: filterData?.minLand,
    land_max_size: filterData?.maxLand,
    has_owner: filterData?.hasOwner,
    has_owner_phone: filterData?.ownerPhoneCheck,
    owner_phone: filterData?.ownerPhone,
    has_owner_street_adrees: filterData?.ownerStreetAddressCheck,
    owner_street_adrees: filterData?.ownerStreetAddress,
    owner_website: filterData?.ownerWebsite,
    has_owner_tax_record: filterData?.ownerTaxRecordCheck,
    tax_record_sent_date: filterData?.taxRecordSentDate,
    tax_record_start_date: filterData?.taxRecordSentStartDate,
    tax_record_end_date: filterData?.taxRecordSentEndDate,
    owner_tags: filterData?.ownerTags,
    tags: filterData?.tags,
    owner_without_tags: filterData?.owner_without_tags,
    last_sold: filterData?.lastSoldOption,
    last_sold_date: filterData?.lastSoldSentDate,
    last_sold_start_date: filterData?.lastSoldStartDate,
    last_sold_end_date: filterData?.lastSoldEndDate,
    sold_date_category: filterData?.lastSoldCategory,
    sold_within_last_day: filterData?.lastSoldWithinLastValue,
    sold_longer_than_day: filterData?.lastSoldLongerThanValue,
    owner: filterData?.owner,
    tags: filterData?.tags,
    owner_type: filterData?.ownerType ?? "",
    count: filterData?.count ?? "",
    start_count: filterData?.start_count ?? "",
    end_count: filterData?.end_count ?? "",
    owner_id: filterData?.owner?.id ?? "",
    within_last_contact_day: filterData?.within_last_contact_day ?? "",
    longer_than_contact_day: filterData?.longer_than_contact_day ?? "",
    tags: filterData?.tags,
    without_property_tags: filterData?.without_property_tags,
    interaction_type: filterData?.interaction_type,
    max_sold_cap_rate: filterData?.max_sold_cap_rate,
    min_sold_cap_rate: filterData?.min_sold_cap_rate,
    min_sold_price: filterData?.min_sold_price,
    max_sold_price: filterData?.max_sold_price,
    last_contact: filterData?.last_contact ?? "date",
    last_update_contact_date: filterData?.lastContactSentDate,
    last_update_start_contact_date: filterData?.lastContactSentSdate,
    last_update_end_contact_date: filterData?.lastContactSentEdate,
    last_update: filterData?.lastUpdateOption ?? "date",
    last_update_date: filterData?.sentDate,
    last_update_start_date: filterData?.lastUpStartDate,
    last_update_end_date: filterData?.lastUpEndDate,
    interaction_type_user: filterData?.interaction_type_user,
    year_count: filterData?.year_count,
    start_year_build_count: filterData?.start_year_build_count,
    end_year_build_count: filterData?.end_year_build_count,
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      propertyName: value?.property_name ?? "",
      storeId: value?.store_id ?? "",
      propertyType: value?.property_type ?? "",
      streetAddress: value?.street_address ?? "",
      city: value?.city ?? "",
      state: value?.state ?? "",
      zip: value?.zip_code ?? "",
      lastUpdateOption: value?.last_update ?? "date",
      last_update_date: value?.sentDate,
      last_update_start_date: value?.lastUpStartDate,
      last_update_end_date: value?.lastUpEndDate,
      lastUpDateCategory: value?.date_category ?? "days",
      lastcontactCategory: value?.date_category_contact ?? "days",
      within_last_day: value?.withinLastDay ?? "",
      longer_than_day: value?.longerThanDay ?? "",
      within_last_contact_day: value?.within_last_contact_day ?? "",
      longer_than_contact_day: value?.longer_than_contact_day ?? "",
      minCaprate: value?.min_rate ?? "",
      maxCaprate: value?.max_rate ?? "",
      minBuilding: value?.building_min_size ?? "",
      maxBuilding: value?.building_max_size ?? "",
      minPrice: value?.min_price ?? "",
      maxPrice: value?.max_price ?? "",
      minLand: value?.land_min_size ?? "",
      maxLand: value?.land_max_size ?? "",
      hasOwner: value?.has_owner ?? "",
      ownerPhoneCheck: value?.has_owner_phone ?? "",
      ownerPhone: value?.owner_phone ?? "",
      ownerStreetAddressCheck: value?.has_owner_street_adrees ?? "",
      ownerStreetAddress: value?.owner_street_adrees ?? "",
      ownerWebsite: value?.owner_website ?? "",
      ownerTaxRecordCheck: value?.has_owner_tax_record ?? "",
      taxRecordSentDate: value?.tax_record_sent_date ?? "",
      taxRecordSentStartDate: value?.tax_record_start_date ?? "",
      taxRecordSentEndDate: value?.tax_record_end_date ?? "",
      ownerTags: value?.owner_tags ?? [],
      owner_without_tags: value?.owner_without_tags,
      tags: value?.tags ?? " ",
      lastSoldOption: value?.last_sold ?? "date",
      lastSoldSentDate: value?.last_sold_date ?? "",
      lastSoldStartDate: value?.last_sold_start_date ?? "",
      lastSoldEndDate: value?.last_sold_end_date ?? "",
      lastSoldCategory: value?.sold_date_category ?? "days",
      lastSoldWithinLastValue: value?.sold_within_last_day ?? "",
      lastSoldLongerThanValue: value?.sold_longer_than_day ?? "",
      owner: value?.owner?.id == null ? { id: "", name: "" } : value?.owner,
      ownerType: value?.ownerType ?? "",
      tags: value?.tags ?? " ",
      count: value?.count ?? "",
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",
      owner_id: value?.owner?.id ?? "",
      tags: value?.tags,
      without_property_tags: value?.without_property_tags,
      last_contact: value?.last_contact ?? "date",
      last_update_contact_date: value?.lastContactSentDate,
      last_update_start_contact_date: value?.lastContactSentSdate,
      last_update_end_contact_date: value?.lastContactSentEdate,
      interaction_type: value?.interaction_type,
      max_sold_cap_rate: value?.max_sold_cap_rate,
      min_sold_cap_rate: value?.min_sold_cap_rate,
      min_sold_price: value?.min_sold_price,
      max_sold_price: value?.max_sold_price,
      interaction_type_user: value?.interaction_type_user,
      year_built_date: value?.year_built_date,
      year_count: value?.year_count,
      start_year_build_count: value?.start_year_build_count,
      end_year_build_count: value?.end_year_build_count,
    };
    userStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  return (
    <div>
      <SavedFilterComponent
        from="property"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialPropertyFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        ref={dropdownRef}
        title={"Filter"}
        desc={"Enter Properties information."}
        onFilter={handleFilter}
        from="property"
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <PropertyFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData}
          onSetError={(value) => setError(value)}
        />
      </RightModal>
    </div>
  );
};

export default PropertyFilter;
